import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ChartModule, UIChart } from 'primeng/chart';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { IDashboardData } from '../../../Utils/_models/dashboard.model';
import { LoaderService } from '../../../Utils/_services/loader.service';
import { AdminService } from '../../../Utils/_services/admin/admin/admin.service';


@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, CardModule, ChartModule, TableModule, TagModule, AvatarModule, ButtonModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements AfterViewInit {
  @ViewChild('revChart') chart?: UIChart;

  userName = 'Anima';
  userAvatar = 'Peets Warrior';

  kpis: Array<{ icon: string; value: string | number; label: string; color: string; iconColor: string }> = [];

  chartData: any;
  chartOptions: any;

  recentLobbies: IDashboardData['recentLobbies'] = [];
  recentUsers: IDashboardData['recentUsers'] = [];

  constructor(private adminService: AdminService,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    const textColor = '#6b7280';
    const gridColor = '#f3f4f6';
    this.kpis = [
      { label: 'Active Users', value: '12,847', icon: 'pi-user', color: '#fff', iconColor: '#fff' },
      { label: 'Total Posts', value: '8,934', icon: 'pi-plus-circle', color: '#fff', iconColor: '#fff' },
      { label: 'Paid Services', value: '1,567', icon: 'pi-dollar', color: '#fff', iconColor: '#fff' },
      { label: 'Total Revenue', value: '$89,432', icon: 'pi-money-bill', color: '#fff', iconColor: '#fff' },
    ];
    this.chartData = {
      labels: [],
      datasets: [
        {
          label: 'Revenue',
          data: [],
          fill: true,
          borderColor: '#F908B7',
          backgroundColor: 'rgba(249, 8, 183, 0.1)',
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 6,
          pointBackgroundColor: '#F908B7',
          pointBorderColor: '#fff',
          pointBorderWidth: 2
        }
      ]
    };

    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          backgroundColor: '#1f2937',
          padding: 8,
          displayColors: false,
          callbacks: {
            title: () => '',
            label: (context: any) => context.parsed.y.toString()
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          ticks: {
            color: textColor,
            font: {
              size: 12
            }
          },
          border: {
            color: '#e5e7eb'
          }
        },
        y: {
          grid: {
            color: gridColor,
            drawBorder: false
          },
          ticks: {
            color: textColor,
            font: {
              size: 12
            }
          },
          border: {
            display: false
          }
        }
      }
    };

    this.loadDashboard();
  }

  ngAfterViewInit(): void {
    this.applyChartGradient();
  }

  loadDashboard(dateRange: string = '30d') {
    // this.loaderService.show();
    this.adminService.getAdminDashboard(dateRange).subscribe({
      next: (res) => {
        const data: IDashboardData = res.data;
        // Update chart data
        const labels = data.revenueByDay.map((i) => i.date);
        const values = data.revenueByDay.map((i) => i.amount);

        this.chartData = {
          labels,
          datasets: [
            {
              label: 'Revenue',
              data: values,
              fill: true,
              borderColor: '#F908B7',
              backgroundColor: 'rgba(249, 8, 183, 0.1)',
              tension: 0.4,
              pointRadius: 0,
              pointHoverRadius: 6,
              pointBackgroundColor: '#F908B7',
              pointBorderColor: '#fff',
              pointBorderWidth: 2
            }
          ]
        };

        setTimeout(() => this.applyChartGradient());

        this.recentLobbies = data.recentLobbies;
        this.recentUsers = data.recentUsers;
        this.loaderService.hide();

      },
      error: (err) => {
        this.loaderService.hide();
        console.error('Failed to load dashboard', err);
      }
    });
  }

  applyChartGradient() {
    const canvas = this.chart?.getCanvas();
    const ctx = canvas?.getContext('2d');
    if (!ctx || !canvas || !this.chartData?.datasets?.length) return;

    // Theme gradient for stroke (matching current theme)
    const gradientStroke = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradientStroke.addColorStop(0, '#E48D00');
    gradientStroke.addColorStop(1, '#F908B7');

    // Theme gradient for fill (matching current theme)
    const gradientFill = ctx.createLinearGradient(0, 0, 0, canvas.height);
    gradientFill.addColorStop(0, 'rgba(249, 8, 183, 0.18)');
    gradientFill.addColorStop(1, 'rgba(228, 141, 0, 0.02)');

    this.chartData = {
      ...this.chartData,
      datasets: this.chartData.datasets.map((d: any) => ({
        ...d,
        borderColor: gradientStroke,
        backgroundColor: gradientFill
      }))
    };
  }

  getStatusSeverity(status: string): string {
    switch (status.toLowerCase()) {
      case 'active':
        return 'success';
      case 'pending':
        return 'warning';
      case 'completed':
        return 'info';
      default:
        return 'secondary';
    }
  }
}
